import React, { useEffect, useMemo, useState } from 'react';
import { useEvent } from '../events/event/EventProvider';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { useBackendApi } from '../../helpers/backendHelper';
import BadgeList from '../badges/BadgeList';
import ButtonApi from '../../components/ButtonApi';
import ReferralCodeSection from './ReferralCodeSection';
import './Invite.scss';

const Invite = () => {
  const [{ event, nftProfile, campaign }] = useEvent();
  const [{ user }] = useGlobalState();
  const backendApi = useBackendApi();
  const [inviteLevelId, setInviteLevelId] = useState(null);
  const [referralCode, setReferralCode] = useState('');
  const [referralStats, setReferralStats] = useState({
    successfulInvites: 0,
    totalInvites: 0
  });

  useEffect(() => {
    if (!event?.eventNames) return;

    // Find the key where name is "invite_badges"
    const inviteLevelId = Object.keys(event.eventNames).find(key => event.eventNames[key]?.name === 'invite_badges');
    setInviteLevelId(inviteLevelId);
  }, [event.eventNames]);

  const [leaderboardData, setLeaderboardData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationInfo, setPaginationInfo] = useState({
    total: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPrevPage: false
  });

  useEffect(() => {
    const fetchReferralData = async () => {
      if (!user) return;
      
      setIsLoading(true);
      try {
        // Get referral code
        const codeResponse = await backendApi.cosmos.getXionReferralCode();
        console.log('Referral code response:', codeResponse);
        setReferralCode(codeResponse?.code || codeResponse?.referralCode || '');
        
        // Get user referral stats
        const userStatsResponse = await backendApi.cosmos.getUserReferralStats();
        console.log('User referral stats response:', userStatsResponse);
        
        if (userStatsResponse) {
          setReferralStats({
            successfulInvites: userStatsResponse.referralCount || 0,
            totalInvites: userStatsResponse.referralCount || 0
          });
        }
        
        // Get referral leaderboard data
        const leaderboardResponse = await backendApi.cosmos.getXionReferralLeaderboard();
        console.log('Leaderboard response:', leaderboardResponse);
        
        if (leaderboardResponse?.leaderboard && Array.isArray(leaderboardResponse.leaderboard)) {
          setLeaderboardData(leaderboardResponse.leaderboard);
          setPaginationInfo({
            total: leaderboardResponse.total || 0,
            totalPages: leaderboardResponse.totalPages || 1,
            hasNextPage: leaderboardResponse.hasNextPage || false,
            hasPrevPage: leaderboardResponse.hasPrevPage || false
          });
        }
      } catch (error) {
        console.error('Error fetching referral data:', error);
        alert.error('Failed to load referral data');
      } finally {
        setIsLoading(false);
      }
    };

    fetchReferralData();
  }, [user, currentPage]);

  const invite_badges = useMemo(() => {
    if (!event?.events?.length) return [];
    return event.events.filter(task => task.levelId === inviteLevelId);
  }, [event?.events, inviteLevelId]);

  const copyReferralLink = () => {
    if (!referralCode) return;
    
    const baseUrl = window.location.origin;
    const referralLink = `${baseUrl}/r/${referralCode}`;
    
    navigator.clipboard.writeText(referralLink).then(() => {
      alert.success('Referral link copied to clipboard!');
    }).catch(() => {
      alert.error('Failed to copy referral link');
    });
  };

  return (
    <>
      <div className='invite-center-text'>
        <div className='text'>
          <p className='profile'>
            INVITE <span>BADGES</span>
          </p>
          <p className='sub-text'>
            Collect them to become XION fire spreadooor!
          </p>
        </div>


        {/* Referral Code Section */}
        <ReferralCodeSection 
          referralCode={referralCode}
          isLoading={isLoading}
          referralStats={referralStats}
          copyReferralLink={copyReferralLink}
        />

         {/* Invite Badges Section */}
         <BadgeList badges={invite_badges} category='invite' />

        {/* Leaderboard Section */}
        {/* <div className='leaderboard-section'>
          <div className='leaderboard-container'>
            <div className='leaderboard-header'>
              <h3>REFERRAL LEADERBOARD</h3>
              <p>Top XION fire spreadoors</p>
            </div>
            <div className='leaderboard-table'>
              {isLoading ? (
                <div className='loading-state'>
                  <p>Loading leaderboard...</p>
                </div>
              ) : leaderboardData.length > 0 ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Address</th>
                        <th>Referral Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leaderboardData.map((item) => (
                        <tr key={item.xionAddress} className={item.xionAddress === user?.xionAddress ? 'current-user' : ''}>
                          <td className='address'>
                            {item.xionAddress ? 
                              `${item.xionAddress.slice(0, 6)}...${item.xionAddress.slice(-4)}` : 
                              'Unknown'
                            }
                          </td>
                          <td className='referral-count'>{item.referralCount || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  
                  <div className='pagination-controls'>
                    <button 
                      className='pagination-btn prev'
                      onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                      disabled={!paginationInfo.hasPrevPage || currentPage === 1}
                    >
                      Previous
                    </button>
                    <span className='page-info'>
                      Page {currentPage} of {paginationInfo.totalPages}
                    </span>
                    <button 
                      className='pagination-btn next'
                      onClick={() => setCurrentPage(prev => prev + 1)}
                      disabled={!paginationInfo.hasNextPage}
                    >
                      Next
                    </button>
                  </div>
                </>
              ) : (
                <div className='empty-state'>
                  <p>No leaderboard data available</p>
                </div>
              )}
            </div>
          </div>
        </div> */}

      </div>
    </>
  );
};

export default Invite; 